import { List } from "immutable";
import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

const records = (state = new List(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCOUNT_BALANCE_SUCCESS:
    case actionTypes.FETCH_RECORDED_BALANCE_SUCCESS:
      if (action.response && action.response.records) {
        return List(action.response.records);
      }
      return state;
    default:
      return state;
  }
};

const recordedBalance = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCOUNT_BALANCE_SUCCESS:
    case actionTypes.FETCH_RECORDED_BALANCE_SUCCESS:
      if (action.response && action.response.recorded_balance !== undefined) {
        return action.response.recorded_balance;
      }
      return state;
    default:
      return state;
  }
};

const subscriptionBalance = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCOUNT_BALANCE_SUCCESS:
    case actionTypes.FETCH_RECORDED_BALANCE_SUCCESS:
      if (action.response && action.response.subscription_balance !== undefined) {
        return action.response.subscription_balance;
      }
      return state;
    default:
      return state;
  }
};

const amountAvailable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCOUNT_BALANCE_SUCCESS:
    case actionTypes.FETCH_RECORDED_BALANCE_SUCCESS:
      if (action.response && action.response.amount_available !== undefined) {
        return action.response.amount_available;
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  records,
  recordedBalance,
  subscriptionBalance,
  amountAvailable,
});
